import { render, staticRenderFns } from "./video_down.vue?vue&type=template&id=b6198516"
import script from "./video_down.vue?vue&type=script&lang=js"
export * from "./video_down.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6198516')) {
      api.createRecord('b6198516', component.options)
    } else {
      api.reload('b6198516', component.options)
    }
    module.hot.accept("./video_down.vue?vue&type=template&id=b6198516", function () {
      api.rerender('b6198516', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/iot/video/video_down.vue"
export default component.exports